module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "section main"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _c('div', {
    staticClass: "columns is-desktop"
  }, _vm._l((_vm.projects), function(project) {
    return _c('div', {
      staticClass: "column is-4"
    }, [_c('div', {
      staticClass: "media section"
    }, [_c('figure', {
      staticClass: "media-left"
    }, [_c('p', {
      staticClass: "image is-128x128"
    }, [_c('img', {
      attrs: {
        "src": _vm.loadImage(project.img) || 'http://bulma.io/images/placeholders/128x128.png'
      }
    })])]), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('p', {
      staticClass: "title",
      domProps: {
        "textContent": _vm._s(project.name)
      }
    }), _c('p', {
      domProps: {
        "textContent": _vm._s(project.description)
      }
    })])])])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading",
    attrs: {
      "id": "projects"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v("Proyectos realizados")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50e6c716!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/views/Projects.pug
// module id = 20
// module chunks = 0